module.exports = __webpack_public_path__ + "img/h2s.6d35ef0d.svg";